import shortid from "shortid"

import Stage from "@frog/source/models/Stage.js"
import Step from "@frog/source/models/Step.js"
import Navigation from "@frog/source/models/Navigation.js"
import Random from "@frog/source/utility/Random.js"

const skills = {}
export default skills

skills["escape"] = {
    "type": "at-end-of-turn",
    "canCounterattack": false,

    "canTarget": function({performerKey, stage, position}) {
        position = position ?? stage.units[performerKey].position
        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) return false
        if(target.affiliation != "good") return false
        return true
    },

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        position = position ?? performer.position

        const target = Stage.findUnitByPosition(stage, position)
        if(target == undefined) {
            return
        }

        if(target.affiliation != "good") {
            return
        }

        Step.add(step, {
            "mark": 0,
            "unit": {
                "key": target.key,
                "hasBeenRemoved": true,
            },
        })

        if(performer.destination != undefined) {
            Step.add(step, {
                "mark": 0,
                "do": function() {
                    const data = {} // TODO: copy the getPreservedStateData from chapters.js
                    console.log("/game/encounters/" + performer.destination, data)
                    Navigation.go("/game/encounters/" + performer.destination, data)
                }
            })
        }

        return step
    },
}

skills["spawn"] = {
    "type": "at-end-of-my-turn",
    "canCounterattack": false,

    "calculateStep": function({performerKey, effectKey, stage, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "alphastage": stage
        })

        const performer = stage.units[performerKey]
        position = position || performer.position

        const target = Stage.findUnitByPosition(stage, position)
        if(target != undefined) {
            return step
        }

        Step.add(step, {
            "mark": 0,
            "unit": {
                "mode": "create",
                "key": shortid.generate(),
                "class": performer.spawnclass,
                "affiliation": "bad",
                "position": position,
                "direction": performer.direction,
            },
        })

        Step.add(step, {
            "mark": 0,
            "units": {
                [performerKey]: undefined
            },
        })

        return step
    },
}
